import users from "./users"
import payouts from "./payouts"
import payoutLines from "./payoutLines"

export const handlers = [...users, ...payouts, ...payoutLines]
